<div class="city-form-wrapper">
  <h2 mat-dialog-title class="city-form-title">
    <mat-icon>location_city</mat-icon>
    {{ isEditMode ? 'Редагувати місто' : 'Нове місто' }}
  </h2>

  <mat-dialog-content>
    <form id="cityForm" [formGroup]="form" (ngSubmit)="onSubmit()" class="city-form">
      <div class="form-section">
        <h3 class="section-title">Назви</h3>

        <div class="form-row form-row--triple">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>English</mat-label>
            <input matInput formControlName="enName" placeholder="City name" />
            @if (form.get('enName')?.invalid && form.get('enName')?.touched) {
            <mat-error>Назва англійською обов'язкова</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Русский</mat-label>
            <input matInput formControlName="ruName" placeholder="Название города" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Українська</mat-label>
            <input matInput formControlName="ukName" placeholder="Назва міста" />
            @if (form.get('ukName')?.invalid && form.get('ukName')?.touched) {
            <mat-error>Назва українською обов'язкова</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Розташування</h3>

        <div class="form-row form-row--half">
          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Країна</mat-label>
            <mat-select formControlName="countryId">
              @for (country of countries; track country.id) {
              <mat-option [value]="country.id">{{ country.name }}</mat-option>
              }
            </mat-select>
            @if (form.get('countryId')?.invalid && form.get('countryId')?.touched) {
            <mat-error>Країна обов'язкова</mat-error>
            }
          </mat-form-field>

          <mat-form-field appearance="outline" class="form-field">
            <mat-label>Регіон</mat-label>
            <mat-select formControlName="regionId">
              <mat-option [value]="null">— Без регіону —</mat-option>
              @for (region of filteredRegions; track region.id) {
              <mat-option [value]="region.id">{{ region.name }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div class="form-section">
        <h3 class="section-title">Синоніми</h3>

        <mat-form-field appearance="outline" class="form-field form-field--full">
          <mat-label>Синоніми</mat-label>
          <mat-chip-grid #chipGrid>
            @for (synonym of synonyms; track synonym) {
            <mat-chip-row (removed)="removeSynonym(synonym)">
              {{ synonym }}
              <button matChipRemove type="button" [attr.aria-label]="'remove ' + synonym">
                <mat-icon>cancel</mat-icon>
              </button>
            </mat-chip-row>
            }
          </mat-chip-grid>
          <input
            placeholder="Додати синонім..."
            [matChipInputFor]="chipGrid"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            (matChipInputTokenEnd)="addSynonym($event)"
          />
        </mat-form-field>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="onCancel()">Скасувати</button>
    <button mat-raised-button color="primary" type="submit" form="cityForm" [disabled]="form.invalid">
      {{ isEditMode ? 'Зберегти' : 'Створити' }}
    </button>
  </mat-dialog-actions>
</div>
